<button
  mat-icon-button
  aria-label="Alerts"
  id="email-alerts-button"
  (click)="openModalWindow()"
>
  <mat-icon class="material-icons-outlined">notifications</mat-icon>
</button>
